/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CostDataRecordCost } from '../models/CostDataRecordCost';
import { CostDataRecordDimensions } from '../models/CostDataRecordDimensions';
import { TimeFrame } from '../models/TimeFrame';

/**
* Total cost for this metering dimension in the specified currency unit.
*/
export class CostDataRecord {
  'recordTimeFrame': TimeFrame;
  /**
  * Number of unique resources that contributed to costs in this record\'s time frame. 
  */
  'resourceCount'?: number;
  'dimensions'?: CostDataRecordDimensions;
  /**
  * Array of cost breakdowns by metering dimension. 
  */
  'costs': Array<CostDataRecordCost>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "recordTimeFrame",
      "baseName": "recordTimeFrame",
      "type": "TimeFrame",
      "format": ""
    },
    {
      "name": "resourceCount",
      "baseName": "resourceCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "dimensions",
      "baseName": "dimensions",
      "type": "CostDataRecordDimensions",
      "format": ""
    },
    {
      "name": "costs",
      "baseName": "costs",
      "type": "Array<CostDataRecordCost>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CostDataRecord.attributeTypeMap;
  }

  public constructor() {
  }
}

